// extracted by mini-css-extract-plugin
module.exports = {"PersonalArea":"style_PersonalArea__1_anC"};